import { FC } from 'react'

import { ISvgClass } from '../interface'

const InsertIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      width="24px"
      height="24px"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M18 9V4c0-.6-.4-1-1-1H9a1 1 0 00-.8.3l-4 4a1 1 0 00-.2.6V20c0 .6.4 1 1 1h4M9 3v4c0 .6-.4 1-1 1H4m11 6v4m-2-2h4m3 0a5 5 0 01-10 0 5 5 0 0110 0z"
        fill="inherit"
      />
    </svg>
  )
}

export default InsertIcon
